import { HTMLAttributes, ReactNode } from 'react';
import CookieConsent from '~/components/CookieConsent';
import Footer from '~/components/layout/Footer';
import Header from '~/components/layout/Header';
import Container from '~/components/ui/Container';
import { cn } from '~/helpers/utils.ts';

interface DefaultLayoutProps extends HTMLAttributes<HTMLDivElement> {
  breadcrumbs?: ReactNode;
  state?: 'default' | 'large';
  consentNeeded?: boolean;
  bgClassName?: string;
}

const DefaultLayout = ({
  breadcrumbs,
  state,
  children,
  consentNeeded = true,
  bgClassName,
}: DefaultLayoutProps) => {
  return (
    <div className="relative flex min-h-dvh flex-col">
      <Header />
      <main className="flex-grow">
        <div
          className={`relative ${state === 'large' ? 'h-[280px]' : 'h-[160px]'} mb-20`}
        >
          {!!breadcrumbs && (
            <Container className="relative z-10 py-4 md:py-8">
              {breadcrumbs}
            </Container>
          )}
          <div
            className={cn(
              'absolute -top-full bottom-0 w-full bg-sand-50',
              bgClassName
            )}
          ></div>
        </div>
        {children}
      </main>
      <Footer />
      {consentNeeded && <CookieConsent />}
    </div>
  );
};

export default DefaultLayout;
